// extracted by css-extract-rspack-plugin
export default {"flags-wrapper":"xLuK73","flagsWrapper":"xLuK73"};